import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { SavedQuerySearch } from '../../entities/saved-queries/saved-query-search.entity';
import { SavedQuery } from '../../entities/saved-queries/saved-query.entity';
import { LoadingBehaviorSubject } from '../../helpers';
import { RecordActionItem } from '../../record/entities/action/record-action-item.class';
import { PaginatedResults } from '../../record/entities/pagination/paginated-results.entity';
import { SavedQueriesService } from '../../services/saved-queries/saved-queries.service';
import { DeleteSavedQueryActionCreator } from '../services/delete-saved-query-action.creator';
import { RestoreSavedQueryActionCreator } from '../services/load-saved-query-action.creator';

@Injectable()
export class SavedQueriesOverviewSandboxService {
    constructor(
        private savedQueriesService: SavedQueriesService,
        private deleteSavedQueryActionCreator: DeleteSavedQueryActionCreator,
        private restoreSavedQueryActionCreator: RestoreSavedQueryActionCreator
    ) {}

    public getSavedQueries(searchParams: SavedQuerySearch): Observable<PaginatedResults<SavedQuery>> {
        return this.savedQueriesService.getSavedQueries(searchParams);
    }

    getDeleteSavedQueryAction(loader$: LoadingBehaviorSubject): RecordActionItem<SavedQuery> {
        return this.deleteSavedQueryActionCreator.getDeleteSavedQueryAction(loader$);
    }

    getRestoreSavedQueryAction(loader$: LoadingBehaviorSubject, tag: string): RecordActionItem<SavedQuery> {
        return this.restoreSavedQueryActionCreator.getRestoreSavedQueryAction(loader$, tag);
    }
}
